// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/partials/presetPicker/PresetMenu";
import {
  manageAddToFavorites,
  manageRemoveFromFavoritesWithId,
  manageRemoveFromLocalsWithId,
} from "actions/presets/thunks";

const mapStateToProps = ({ user: { isLogged } }) => {
  return {
    isLogged,
  };
};

const mapDispatchToProps = {
  manageAddToFavorites,
  manageRemoveFromFavoritesWithId,
  manageRemoveFromLocalsWithId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
